export class DeletePhotoDialogOldComponent {
  constructor($scope) {
    Object.assign(this, {
      $scope,
      file: $scope.ngDialogData.file,
    });
  }

  getPhotoLabel(file) {
    switch(file.id) {
      case 12:
        return 'Selfie Photo';
    }
  }

  shouldDeletePhoto(approve = false) {
    this.$scope.closeThisDialog({
      approve,
    });
  }
}

DeletePhotoDialogOldComponent.$inject = ["$scope"];
angular.module('pims').controller('DeletePhotoDialogComponent', DeletePhotoDialogOldComponent);
